import BaseLayer from "./BaseLayer";
import {drawCircle, drawLine, drawRectangle, imagetoCanvasPosHelper} from "../utils/map_utils";
import {TileViewerConstants, zProfileFolderPath} from "../../../utils/const";
import {Grid, Stack} from "@mui/material";
import {getCountyKey} from "../../neotileviewer/tile_viewer_map_utils";

class Islands extends BaseLayer {

    id = "islands";
    label = "Islands";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {
            slide,
            islands,
            focusOffset,
            deviceSettings,
            countyTiltInfo,
            scanFocusDebug,
            focusDirPath,
            textColor
        } = this.props;
        let {bucket_name, tile_viewer_path, loc_on_machine, x_fields, uperpixel, tile_height} = slide
        let index = 0;
        let xOffset = focusOffset['xy']["x_offset"];
        let yOffset = focusOffset['xy']["y_offset"];
        if (islands.length > 0 && !islands[0]["counties"]) {
            for (let i = 0; i < islands.length; i++) {
                let rectStartPoint = imagetoCanvasPosHelper({device_settings: deviceSettings},
                    slide, islands[i]["islandBoundary"]["x"], islands[i]["islandBoundary"]["y"]);
                let rectEndPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, slide,
                    islands[i]["islandBoundary"]["x"] + islands[i]["islandBoundary"]["width"],
                    islands[i]["islandBoundary"]["y"] + islands[i]["islandBoundary"]["height"]);
                let bounds = [
                    [rectStartPoint.x, rectStartPoint.y],
                    [rectEndPoint.x, rectStartPoint.y],
                    [rectEndPoint.x, rectEndPoint.y],
                    [rectStartPoint.x, rectEndPoint.y],
                    [rectStartPoint.x, rectStartPoint.y]
                ];
                index = (index + 1) % 3;
                drawRectangle(bounds, this.layer.getSource(), false, 4, TileViewerConstants.COUNTY[index]
                    , "", textColor);
            }
        }
        else {
            for(let i = 0; i < islands.length; i++) {
                if (islands[i]["islandKey"]["takeNumber"] === 0) {
                    for (let idx = 0; idx < islands[i]["counties"].length; idx++) {
                        const abandonedCounty = islands[i]["counties"][idx]["abandoned"];
                        if (abandonedCounty !== undefined && abandonedCounty === true) {
                            continue;
                        }
                        const countyBoundary = islands[i]["counties"][idx]["countyBoundary"];
                        let rectStartPoint = imagetoCanvasPosHelper({device_settings: deviceSettings},
                            slide, slide.x_fields - countyBoundary["x"],
                            countyBoundary["y"]);
                        let rectEndPoint = imagetoCanvasPosHelper({device_settings: deviceSettings},
                            slide, slide.x_fields - countyBoundary["x"] -
                            countyBoundary["width"], countyBoundary["y"] + countyBoundary["height"]);
                        let bounds = [
                            [rectStartPoint.x, rectStartPoint.y],
                            [rectEndPoint.x, rectStartPoint.y],
                            [rectEndPoint.x, rectEndPoint.y],
                            [rectStartPoint.x, rectEndPoint.y],
                            [rectStartPoint.x, rectStartPoint.y]
                        ];
                        index = (index + 1) % 3;
                        drawRectangle(bounds, this.layer.getSource(), false, 4,
                            TileViewerConstants.COUNTY[index], "", textColor);
                    }
                }
            }
            if (scanFocusDebug !== undefined && scanFocusDebug['debugUnitMap'] !== undefined) {
                for (const [key, value] of Object.entries(scanFocusDebug['debugUnitMap'])) {
                    console.log(`__da ${key}: ${value}`);
                    const countyBoundary = value["county"]["countyBoundary"];
                    const takeNumber = value["county"]["countykey"]["islandKey"]["takeNumber"];
                    if (takeNumber === 0) {
                        let rectStartPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                            x_fields - countyBoundary["x"], countyBoundary["y"]);
                        let rectEndPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                            x_fields - countyBoundary["x"] - countyBoundary["width"],
                            countyBoundary["y"] + countyBoundary["height"]);
                        const midX = (rectStartPoint.x + rectEndPoint.x) / 2;
                        
                        let logs = [];
                        for (const log of value["logs"]) {
                            logs.push(<Grid>{log}</Grid>);
                        }
                        let popupText = (
                            <Stack style={{'width': '500px'}}>
                                {logs}
                            </Stack>
                        );
                        drawCircle(midX, rectStartPoint.y - 3 * tile_height * uperpixel, 0.15 * tile_height * uperpixel,
                            this.layer.getSource(), "", 10, "rgba(255,87,51,0.78)", popupText, textColor, 12);
                    }
                }
            }
            let counter = 1;
            for (const tiltInfo of countyTiltInfo) {
                const abandonedCounty = tiltInfo["county"]["abandoned"];
                if (abandonedCounty !== undefined && abandonedCounty === true) {
                    continue;
                }
                const adjacentFU = tiltInfo['focusUnit'];
                const countyBoundary = tiltInfo["county"]["countyBoundary"];
                let rectStartPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                    x_fields - countyBoundary["x"], countyBoundary["y"]);
                let rectEndPoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide,
                    x_fields - countyBoundary["x"] - countyBoundary["width"],
                    countyBoundary["y"] + countyBoundary["height"]);
                const midX = (rectStartPoint.x + rectEndPoint.x) / 2;
                if (adjacentFU === null || adjacentFU === undefined) {
                    let popupText = (
                        <Stack>{"Adjacent Focus Unit is null"}</Stack>
                    );
                    drawCircle(midX, rectStartPoint.y - 2 * tile_height * uperpixel, 0.3 * tile_height * uperpixel,
                        this.layer.getSource(), "", 10, "#555555", popupText, textColor);
                    continue;
                }
                if (adjacentFU['tiledFocusedAt'] === null) {
                    adjacentFU['tiledFocusedAt'] = {'first': "unknown", 'second': "unknown"};
                }
                let zProfilePath = '';
                for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                    const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                    const lastElement = path.pop();
                    if (adjacentFU['unifiedFocusId'] === parseInt(lastElement)) {
                        zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                    }
                }

                let link1 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path + zProfileFolderPath
                    + zProfilePath;
                let popupText = (
                    <Stack>
                        <Grid>{"AdjacentFU ID DOWN " + adjacentFU['unifiedFocusId'] +
                            "(" + adjacentFU['focusedDown'] + ")"}</Grid>
                        <Grid>{"County Key: " + getCountyKey(tiltInfo['adjacentFUCountyKey']['islandKey'],
                            tiltInfo['adjacentFUCountyKey']['countyId'])}</Grid>
                        <Grid><a href={link1}>{"ID " + adjacentFU['unifiedFocusId'] + " Location"}</a></Grid>
                        <Grid>{"Tiled position Col: " + adjacentFU['tiledFocusedAt']['first'] + " Row: " +
                            adjacentFU['tiledFocusedAt']['second']}</Grid>
                    </Stack>
                );

                drawCircle(midX, rectStartPoint.y - 2 * tile_height * uperpixel, 0.3 * tile_height * uperpixel,
                    this.layer.getSource(), "", 10, "rgba(255,234,0,0.78)", popupText, textColor);
                drawLine(midX, rectStartPoint.y - tile_height * uperpixel, 1, this.layer.getSource(),
                    "Scan Order:" + counter.toString(), 10, "#f4c2c2", "", textColor, 12);
                counter += 1;
            }
        }
        resolve();
    });
}

export default Islands;
